import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { gridConfig, tokens } from '../../../../constants';
export var getGridColStyles = (props, breakpoint) => {
  var config = props.config,
    propBreakpoints = props.breakpoints,
    noGutter = props.noGutter,
    noTopGutter = props.noTopGutter;
  var _ref = (config === null || config === void 0 ? void 0 : config[breakpoint]) || {},
    rowSpacing = _ref.rowSpacing,
    columnSpacing = _ref.columnSpacing;
  var breakopintValues = [propBreakpoints === null || propBreakpoints === void 0 ? void 0 : propBreakpoints.xs, propBreakpoints === null || propBreakpoints === void 0 ? void 0 : propBreakpoints.sm, propBreakpoints === null || propBreakpoints === void 0 ? void 0 : propBreakpoints.md, propBreakpoints === null || propBreakpoints === void 0 ? void 0 : propBreakpoints.lg, propBreakpoints === null || propBreakpoints === void 0 ? void 0 : propBreakpoints.xl];
  var lastVal = 12;
  breakopintValues === null || breakopintValues === void 0 ? void 0 : breakopintValues.forEach((value, idx) => {
    if (!value) {
      if (value !== 0) {
        breakopintValues[idx] = breakopintValues[idx - 1] || lastVal;
      }
    } else lastVal = breakopintValues === null || breakopintValues === void 0 ? void 0 : breakopintValues[idx];
  });
  var xs = breakopintValues[0],
    sm = breakopintValues[1],
    md = breakopintValues[2],
    lg = breakopintValues[3],
    xl = breakopintValues[4];
  var breakpoints = {
    xs,
    sm,
    md,
    lg,
    xl
  };
  var colValue = breakpoints[breakpoint];
  return StyleSheet.create({
    container: Object.assign(Object.assign({
      display: colValue === 0 ? 'none' : 'flex',
      width: colValue * 100 / 12 + "%"
    }, !noGutter && {
      paddingHorizontal: tokens.spacing[columnSpacing] / 2
    }), !noGutter && !noTopGutter && {
      paddingTop: tokens.spacing[rowSpacing]
    })
  });
};
export var getGridColProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var _ref2 = merge(gridConfig === null || gridConfig === void 0 ? void 0 : gridConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.grid) === null || _a === void 0 ? void 0 : _a[theme]) || {},
    config = _ref2.config,
    configProps = _ref2.col;
  return Object.assign(Object.assign({
    theme,
    config
  }, configProps), props);
};